import { EventEmitter, Injectable } from '@angular/core';
import { AccountCompanyDTO } from '../models/dtos/account-company.dto';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountCompany } from '../models/account-company.model';
import { HttpClient } from '@angular/common/http';
import { IApiResult } from 'common';
import { UserDTO } from '../models/dtos/user.dto';

import { AppConfigService } from 'common';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  companySaved = new EventEmitter();

  constructor(
    private httpClient: HttpClient,
    private env: AppConfigService
  ) {}

  getCompany(): Observable<AccountCompany> {
    return this.httpClient
      .get<IApiResult<AccountCompanyDTO>>('/v2/Accounts/:accountCode/company')
      .pipe(map((response) => AccountCompany.fromDto(response.value)));
  }

  getCompanyValidation(): Observable<boolean> {
    return this.httpClient.get<IApiResult<any>>('/v2/Accounts/:accountCode/company/validated').pipe(map((response) => response.value.isValidated));
  }

  validateCompanyDetails(): Observable<boolean> {
    return this.httpClient.post<IApiResult<null>>('/v2/Accounts/:accountCode/company/validated', {}).pipe(map((response) => response.success));
  }

  updateCompany(data: AccountCompany): Observable<boolean> {
    const dto = data.convertToDto();
    return this.httpClient.put<IApiResult<any>>('/v2/Accounts/:accountCode/company', dto).pipe(
      map((response) => {
        this.companySaved.emit();
        return !(response.errors && response.errors.length > 0);
      })
    );
  }
}
